import { useMemo } from "react";
import { MeshBasicMaterial, PlaneGeometry } from "three";
import { useCabinetStore } from "../../../../context/StoreContext";
import { useCanvasStore } from "../../../../hooks/useCanvasStore";
import { FIGURE_HEIGHT, FIGURE_WIDTH } from "./Figure";

export function Room() {
	const { state } = useCabinetStore();
	const { fullScreen } = useCanvasStore();

	const { width, depth, height } = useMemo(() => {
		const width = (state.width + FIGURE_WIDTH + 5000) / 1000;
		const depth = 5;
		const height = (Math.max(state.height, FIGURE_HEIGHT) + 400) / 1000;

		return { width, depth, height };
	}, [state.width, state.height]);

	const floorGeometry = useMemo(() => new PlaneGeometry(width, depth), [width, depth]);
	const floorMaterial = useMemo(() => {
		return new MeshBasicMaterial({ color: "#f9f9f9", toneMapped: false });
	}, []);

	const wallGeometry = useMemo(() => new PlaneGeometry(width, height), [width, height]);
	const wallMaterial = useMemo(() => {
		return new MeshBasicMaterial({ color: "#fcfcfc", toneMapped: false });
	}, []);

	if (fullScreen) return null;

	return (
		<>
			<mesh
				geometry={floorGeometry}
				material={floorMaterial}
				position={[state.width / 1000 / 2, 0, depth / 2]}
				rotation={[-Math.PI / 2, 0, 0]}
				receiveShadow
			/>

			<mesh
				geometry={wallGeometry}
				material={wallMaterial}
				position={[state.width / 1000 / 2, height / 2, 0]}
				rotation={[0, 0, 0]}
				receiveShadow
			/>
		</>
	);
}
